﻿import { ServiceOptions, serviceRequest } from "@serenity-is/corelib";
import { AskManualRequest } from "./AskManualRequest";
import { AskManualResponse } from "./AskManualResponse";

export namespace ManualService {
    export const baseUrl = 'Common/Manual';

    export declare function Ask(request: AskManualRequest, onSuccess?: (response: AskManualResponse) => void, opt?: ServiceOptions<any>): PromiseLike<AskManualResponse>;

    export const Methods = {
        Ask: "Common/Manual/Ask"
    } as const;

    [
        'Ask'
    ].forEach(x => {
        (<any>ManualService)[x] = function (r, s, o) {
            return serviceRequest(baseUrl + '/' + x, r, s, o);
        };
    });
}